import { render, staticRenderFns } from "./ComplaintEdit.vue?vue&type=template&id=e65bd332&scoped=true&"
import script from "./ComplaintEdit.vue?vue&type=script&lang=js&"
export * from "./ComplaintEdit.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintEdit.vue?vue&type=style&index=0&id=e65bd332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65bd332",
  null
  
)

export default component.exports